import { number, object, string } from "yup";

export const dockSchema = object().shape({
  Code: string().max(2, "Dock Code must be at most 2 characters").default(""),
  NumberOfTrucks: number()
    .nullable()
    .transform((value: number, originalValue: number | undefined | null) =>
      !originalValue ? null : value
    ),
});
